import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";
import useTranslations from "../../core/i18n/useTranslations";
import { Spacer } from "../Layout/Layout";

export const ManualSyncInfoModal = ({
  isOpen,
  setIsOpen,
  fetchObject,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  fetchObject: () => void;
}) => {
  const t = useTranslations();

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("Objects:sync_in_queue_header")}
      fixedWidth="576px"
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        fetchObject();
      }}
      submitBtn={{
        text: t("Common:ok"),
        variant: "secondary",
        onClick: () => {
          setIsOpen(false);
          fetchObject();
        },
      }}
    >
      <p>{t("Objects:sync_in_queue_description")}</p>
      <Spacer size={16} />
      <p>{t("Objects:sync_in_queue_note")}</p>
    </PrimeModal>
  );
};
